/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getFieldZoneLayout } from "cms/fields/field-utils";
import { ComponentFieldDisplay } from "./display";
import { ComponentFieldEdit } from "./edit";

const ComponentField = (props) => {

    const zoneProps = {
        ...props,  // contains: field, model, position
        displayComponent: <ComponentFieldDisplay />,
        editComponent: <ComponentFieldEdit />,
    };
    return getFieldZoneLayout(zoneProps);
};
ComponentField.displayName = "ComponentField";
export { ComponentField };
